import React from "react";


import Services from "../components/ServicesSection";
import WhyUs from "../components/WhyUsSection";
import ContactUs from "../components/ContactSection";
import CTAPage from "../components/CTAPage";
import Service from "../components/Serviceshero"

const HomePage = ({ isDarkMode }) => {
  

  return (
    <>
      <Service isDarkMode={isDarkMode} />
      <Services isDarkMode={isDarkMode} />
      <WhyUs isDarkMode={isDarkMode} />
      <CTAPage isDarkMode={isDarkMode} />
      <ContactUs isDarkMode={isDarkMode} />
    </>
  );
};

export default HomePage;
